class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange(e) {
    const { isCombinedProduct, targetUrl } = this.combinedListingCheck(e);

    this.toggleAddButton(true, "", false);

    if (isCombinedProduct) {
      this.fetchProductSection(targetUrl);
      return; // Stop execution if false
    }

    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateSaleBadge();
    }
  }

  combinedListingCheck(e) {
    const currentUrl = window.location.pathname;
    const targetUrl = e.target.dataset.productUrl;
    let isCombinedProduct = false;

    if (targetUrl != undefined && currentUrl != targetUrl) {
      isCombinedProduct = true;
    }

    return { isCombinedProduct, targetUrl };
  }

  async fetchProductSection(newProductUrl) {
    const productElement = this.closest(".main-product, .pdp3");
    const productSectionId = this.dataset.section;
    let params = `section_id=${productSectionId}&`;

    const selectedOptionValues = Array.from(
      this.querySelectorAll("fieldset input:checked")
    )
      .map((element) => element.dataset.optionValueId)
      .join(",");
    params += `option_values=${selectedOptionValues}`;

    fetch(`${newProductUrl}?${params}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        productElement.innerHTML =
          html.querySelector(".main-product, .pdp3").innerHTML;
        window.history.replaceState({}, "", `${newProductUrl}`);
      });
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGridySlider = document.getElementById(
      `slider-${this.dataset.section}`
    );
    const thumbnailsGridySlider = document.getElementById(
      `thumbnail-slider-${this.dataset.section}`
    );

    if (mediaGridySlider) {
      mediaGridySlider.scrollToSlideByID(
        `item-${this.currentVariant.featured_media.id}`
      );
    }

    if (thumbnailsGridySlider) {
      thumbnailsGridySlider.scrollToSlideByID(
        `thumbnail-item-${this.currentVariant.featured_media.id}`
      );
    }

    const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
    const isGrid =
      mediaGridySlider.dataset.desktopEnabled === "false" ? true : false;
    if (isDesktop && isGrid) {
      document
        .getElementById(`item-${this.currentVariant.featured_media.id}`)
        ?.scrollIntoView();
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateSaleBadge() {
    if (!this.currentVariant) return;

    const saleBadge = document.getElementById("saleBadge");
    if (!saleBadge) return;

    const comparePrice = this.currentVariant.compare_at_price;
    const salePrice = this.currentVariant.price;

    if (comparePrice && comparePrice > salePrice) {
      const badgeType = saleBadge.dataset.saleBadgeType || "default";
      let badgeText = "";

      if (badgeType === "savings") {
        // Calculate savings amount
        const savingsAmount = comparePrice - salePrice;
        const formattedSavings = Woolman.Utils.formatMoney(savingsAmount);
        badgeText = window.saleBadgeStrings.savings.replace(
          "[amount]",
          formattedSavings
        );
      } else if (badgeType === "percentage") {
        // Calculate discount percentage
        const discountPercentage = Math.floor(
          ((comparePrice - salePrice) / comparePrice) * 100
        );
        badgeText = window.saleBadgeStrings.percentage.replace(
          "[percentage]",
          discountPercentage
        );
      } else {
        // Default badge type
        badgeText = window.saleBadgeStrings.default;
      }

      saleBadge.textContent = badgeText;
      saleBadge.classList.remove("hide");
    } else {
      // Hide badge if no discount
      saleBadge.classList.add("hide");
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-product-buy-bar`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector(
      "[data-product-inventory]"
    );

    if (
      !this.productInventoryNode ||
      !window.inventories ||
      !window.inventories[this.dataset.productId]
    )
      return;

    this.inventoryThreshold = parseInt(
      this.productInventoryNode.dataset.threshold
    );
    this.showQuantityInStock =
      this.productInventoryNode.dataset.showQuantityInStock;

    const variantInventoryObject =
      window.inventories[this.dataset.productId][this.currentVariant?.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management) {
      this.toggleInventoryQuantity(false);
      this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === "shopify") {
      if (
        variantInventoryObject.quantity <= 0 &&
        variantInventoryObject.incoming === "true" &&
        variantInventoryObject.quantity < this.inventoryThreshold
      ) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(
          true,
          variantInventoryObject.next_incoming_date
        );
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show === false) {
      this.productInventoryNode.classList.add("hide");
      return;
    }

    this.productInventoryNode.classList.remove(
      "inventory-status--in-stock",
      "inventory-status--low",
      "inventory-status--sold-out",
      "inventory-status--sold-out-continue-selling"
    );

    if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) <= parseInt(this.inventoryThreshold) &&
      parseInt(quantity) > 0
    ) {
      this.productInventoryNode.classList.add("inventory-status--low");
      if (this.showQuantityInStock === "true") {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left_with_quantity.replace(
            "[quantity]",
            quantity
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.few_left;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) > parseInt(this.inventoryThreshold)
    ) {
      this.productInventoryNode.classList.add("inventory-status--in-stock");
      if (this.showQuantityInStock === "true") {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock_with_quantity.replace(
            "[quantity]",
            quantity
          );
      } else {
        this.productInventoryNode.firstElementChild.textContent =
          window.variantStrings.inventory.in_stock;
      }
    } else if (
      this.currentVariant &&
      this.currentVariant.available &&
      parseInt(quantity) < 1
    ) {
      this.productInventoryNode.classList.add(
        "inventory-status--sold-out-continue-selling"
      );
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock_continue_selling;
    } else {
      this.productInventoryNode.classList.add("inventory-status--sold-out");
      this.productInventoryNode.firstElementChild.textContent =
        window.variantStrings.inventory.out_of_stock;
    }

    this.productInventoryNode.classList.remove("hide");
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector(
      "[data-incoming-inventory]"
    );
    if (!incomingInventoryNode) return;

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add("hide");

      return;
    }

    let string = !date
      ? window.variantStrings.inventory.waiting_for_stock
      : window.variantStrings.inventory.will_be_in_stock_after.replace(
          "[date]",
          date
        );

    incomingInventoryNode.classList.remove("hide");
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`
        );
        const destinationBuyBarInfo = document.getElementById(
          `buy-bar-info-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        const buyBarInfoSource = html.getElementById(
          `buy-bar-info-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo)
          destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;

        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "hidden",
            skuSource.classList.contains("hidden")
          );
        }

        /* MAB Fix 1d – Volume Discount Table: bei Variantenwechsel aktualisieren */
        const vdtDestination = document.querySelector('[data-volume-discount-table]');
        const vdtSource = html.querySelector('[data-volume-discount-table]');
        if (vdtSource && vdtDestination) {
          vdtDestination.innerHTML = vdtSource.innerHTML;
          vdtDestination.removeAttribute('data-vdt-initialized');
          if (typeof window.initVolumeDiscountTable === 'function') {
            window.initVolumeDiscountTable();
          }
        }
        /* /MAB Fix 1d */

        /* MAB Prio 2 – Produkt-Titel bei Variantenwechsel aktualisieren */
        const titleDestination = document.getElementById(
          `ProductTitle-${this.dataset.section}`
        );
        const titleSource = html.getElementById(
          `ProductTitle-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (titleSource && titleDestination) {
          titleDestination.innerHTML = titleSource.innerHTML;
        }
        /* /MAB Prio 2 */

        /* MAB Prio 4 – Produktdaten bei Variantenwechsel aktualisieren */
        const metaDestination = document.querySelector('[data-product-meta]');
        const metaSource = html.querySelector('[data-product-meta]');
        if (metaSource && metaDestination) {
          metaDestination.innerHTML = metaSource.innerHTML;
        }
        /* /MAB Prio 4 */

        /* MAB PDP v3 – Sections mit [data-variant-section] (z. B. Produktinformationen,
           Produktinfo-Leiste) werden per Section-Rendering-API neu geladen, damit
           variantenabhängige Inhalte (PZN, Downloads, Lieferumfang) aktuell bleiben. */
        const variantSections = document.querySelectorAll('[data-variant-section], .product-info-bar-section');
        variantSections.forEach((sectionEl) => {
          const shopifySection = sectionEl.closest('.shopify-section');
          const sectionId = shopifySection?.id?.replace('shopify-section-', '');
          if (!sectionId) return;
          fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
            .then((resp) => resp.text())
            .then((respText) => {
              const sectionHtml = new DOMParser().parseFromString(respText, 'text/html');
              const fresh = sectionHtml.querySelector('[data-variant-section], .product-info-bar-section');
              if (!fresh) return;
              sectionEl.innerHTML = fresh.innerHTML;
              sectionEl.removeAttribute('data-pi-initialized');
              if (typeof window.initProductInformation === 'function') window.initProductInformation();
            })
            .catch((err) => console.error('Variant section update failed:', err));
        });
        /* /MAB PDP v3 */

        /* MAB Prio 10 – Lieferzeit bei Variantenwechsel aktualisieren */
        const deliveryDestination = document.querySelector('[data-product-delivery]');
        const deliverySource = html.querySelector('[data-product-delivery]');
        if (deliverySource && deliveryDestination) {
          deliveryDestination.outerHTML = deliverySource.outerHTML;
        }
        /* /MAB Prio 10 */

        /* MAB Leasing – Rate/Laufzeit bei Variantenwechsel aktualisieren.
           Nur das Inline-Widget wird getauscht; das Modal bleibt erhalten
           (liegt ggf. in document.body) und wird via sync() befüllt. */
        const leasingDestination = document.querySelector('[data-product-leasing]');
        const leasingSource = html.querySelector('[data-product-leasing]');
        if (leasingSource && leasingDestination) {
          leasingDestination.innerHTML = leasingSource.innerHTML;
          Array.from(leasingSource.attributes).forEach((attr) => {
            leasingDestination.setAttribute(attr.name, attr.value);
          });
          Array.from(leasingDestination.attributes).forEach((attr) => {
            if (!leasingSource.hasAttribute(attr.name)) {
              leasingDestination.removeAttribute(attr.name);
            }
          });
          if (window.MABLeasing) window.MABLeasing.sync(leasingDestination);
        }
        /* /MAB Leasing */

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        const isPreorder = this.dataset.isPreorder === "true";
        const variantAvailable = this.currentVariant.available;
        // MAB Preorder: bei aktivem Preorder-Tag bleibt der Button klickbar – auch bei Sold-Out
        this.toggleAddButton(
          !variantAvailable && !isPreorder,
          isPreorder ? window.variantStrings.preOrder : window.variantStrings.soldOut
        );
        // MAB Back-In-Stock: Trigger nur bei nicht-preorder & sold-out anzeigen
        this.toggleBackInStock(!variantAvailable && !isPreorder);
      });
  }

  toggleBackInStock(show) {
    const trigger = document.querySelector(
      `[data-back-in-stock-trigger][data-section="${this.dataset.section}"]`
    );
    if (!trigger) return;
    if (show) {
      trigger.setAttribute("data-variant-id", this.currentVariant.id);
      trigger.removeAttribute("hidden");
    } else {
      trigger.setAttribute("hidden", "");
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const multiplyButtons = productForm.querySelectorAll(
      ".btn--add-multiplier"
    );
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
      if (multiplyButtons) {
        multiplyButtons.forEach((button) => {
          button.disabled = true;
        });
      }
    } else {
      addButton.removeAttribute("disabled");
      if (this.dataset.isPreorder == "true") {
        addButtonText.textContent = window.variantStrings.preOrder;
      } else {
        addButtonText.textContent = window.variantStrings.addToCart;
      }
      if (multiplyButtons) {
        multiplyButtons.forEach((button) => {
          button.removeAttribute("disabled");
        });
      }
    }

    const productForm_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    if (productForm_BuyBar) {
      const addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
      const addButtonText_BuyBar = productForm_BuyBar.querySelector(
        '[name="add"] > span'
      );

      if (disable) {
        addButton_BuyBar.setAttribute("disabled", "disabled");
        if (text) addButtonText_BuyBar.textContent = text;
      } else {
        addButton_BuyBar.removeAttribute("disabled");
        if (this.dataset.isPreorder == "true") {
          addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("hidden");

    const button_BuyBar = document.getElementById(
      `product-form-${this.dataset.section}-product-buy-bar`
    );
    const addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
    const addButtonText_BuyBar = button_BuyBar.querySelector(
      '[name="add"] > span'
    );
    const price_BuyBar = document.getElementById(
      `price-${this.dataset.section}-product-buy-bar`
    );
    if (!addButton_BuyBar) return;
    addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
    if (price_BuyBar) price_BuyBar.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    // MAB: Auch Change-Events auf Select-Dropdowns innerhalb von variant-radios hören
    this.querySelectorAll('select.field__input').forEach((select) => {
      select.addEventListener('change', this.onVariantChange.bind(this));
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    // MAB: Unterstützt sowohl fieldset (Buttons) als auch .product-form__input (Dropdowns)
    const optionContainers = Array.from(this.querySelectorAll("fieldset, .product-form__input--dropdown"));
    this.options = optionContainers.map((container) => {
      // Prüfe zuerst auf Radio-Buttons
      const checkedRadio = Array.from(container.querySelectorAll("input")).find(
        (radio) => radio.checked
      );
      if (checkedRadio) return checkedRadio.value;
      // Fallback: Select-Dropdown
      const select = container.querySelector("select");
      if (select) return select.value;
      return '';
    });

    this.updateLegends();
  }

  updateLegends() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    fieldsets.forEach((fieldset) => {
      const legend = fieldset.querySelector("legend [data-variant-legend]");
      if (!legend) return;
      const selectedOption = Array.from(
        fieldset.querySelectorAll("input")
      ).find((radio) => radio.checked);
      if (selectedOption) legend.textContent = selectedOption.getAttribute("value");
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductBuyBar extends HTMLElement {
  constructor() {
    "use strict";
    super();

    let classes = { show: "show" };
    let mainProductForm = document.querySelector(".product-form");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // In view -> Hide bar
            this.classList.remove(classes.show);
          } else if (window.scrollY > 200) {
            // Out of view AND scrolled a little from top -> Show bar
            this.classList.add(classes.show);
          }
        });
      },
      { threshold: 0.25 }
    );

    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      let siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
  }
}
customElements.define("product-buy-bar", ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector("select");
    this.image = this.querySelector(".card-media img");

    if (this.select) {
      this.select.addEventListener("change", (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute("data-variant-img-src");
        if (newImgSrc) {
          this.updateImage(newImgSrc);
        }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image) {
      this.image.src = newImgSrc;
    }
  }
}

customElements.define("upsell-card", UpsellCard);

class ProductLeaflet extends HTMLElement {
  constructor() {
    super();
    this.leafletTag = this.querySelector("[data-leaflet-tag]");
    this._loadPDFLeaflet();
  }

  async _loadPDFLeaflet(variant = false) {
    if (!this.leafletTag) return;

    const pzn = variant
      ? variant.metafields?.plytix?.pzn?.value
      : this.leafletTag.dataset.pzn;

    // Direkt in der Produktbeschreibung verlinkte Packungsbeilage (z. B. Apothekenartikel ohne
    // Treffer im Leaflet-Service): wird genutzt, wenn keine PZN vorliegt oder der Service nichts liefert.
    const fallbackUrl = this.leafletTag.dataset.fallbackUrl || "";
    const useFallback = () => {
      if (!fallbackUrl) return false;
      this.leafletTag.href = fallbackUrl;
      this._toggleLeafletVisibility(true);
      return true;
    };

    if (!pzn) {
      if (useFallback()) return;
      console.error("No PZN found for PDF Leaflet");
      this._toggleLeafletVisibility(false);
      return;
    }

    try {
      const pdfLink = await this._fetchPDFLeafletLink(pzn);

      if (pdfLink) {
        this.leafletTag.href = pdfLink;
        this._toggleLeafletVisibility(true);
      } else if (!useFallback()) {
        this._toggleLeafletVisibility(false);
      }
    } catch (error) {
      /**
       * This happens on localhost due to CORS policy.
       * For testing you can disable the visibility toggle
       * and set the href manually e.g.
       * ```
       * this.leafletTag.href = "https://api.gebrauchs.info/6067231c2395ba113d59d493df6618aai";
       * ```
       */
      console.error("Failed to load PDF Leaflet:", error);
      if (!useFallback()) this._toggleLeafletVisibility(false);
    }
  }

  async _fetchPDFLeafletLink(pzn) {
    const serverUrl = this.leafletTag.dataset.serverUrl;

    if (!serverUrl) {
      console.error("Server URL not found. Make sure the server-url is set.");
      throw new Error("Server URL not set");
    }

    const url = `${serverUrl}/?pzn=${pzn}`;

    try {
      const response = await fetch(url);

      if (response.status === 404) {
        console.log("PDF Leaflet not found (404)");
        return null;
      }

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return data?.pdf || null;
    } catch (error) {
      console.error("Error fetching PDF link:", error);
      throw error;
    }
  }

  _toggleLeafletVisibility(show) {
    if (!this.leafletTag) return;

    const leafletParent = this.leafletTag.parentNode;
    leafletParent.classList.toggle("hidden", !show);

    if (!show) {
      console.log("Leaflet tag hidden due to 404 or error");
    }
  }
}

customElements.define("product-leaflet", ProductLeaflet);
